import { render, staticRenderFns } from "./Participantes.vue?vue&type=template&id=1a74ff57&"
import script from "./Participantes.vue?vue&type=script&lang=js&"
export * from "./Participantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports